var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7725 10.1046C10.2508 10.6263 9.25323 11.6239 8.41512 12.462C7.63407 13.243 6.36857 13.2431 5.58753 12.462C4.76513 11.6396 3.78439 10.6589 3.23007 10.1046C1.14727 8.02177 1.14727 4.64489 3.23007 2.5621C5.31286 0.479301 8.68974 0.479301 10.7725 2.5621C12.8553 4.64489 12.8553 8.02177 10.7725 10.1046Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 6.33333C9.0013 7.4379 8.10587 8.33333 7.0013 8.33333C5.89673 8.33333 5.0013 7.4379 5.0013 6.33333C5.0013 5.22876 5.89673 4.33333 7.0013 4.33333C8.10587 4.33333 9.0013 5.22876 9.0013 6.33333Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.ac6d3e63fad3baf1e76e4e3be94c3244.svg";
export { ForwardRef as ReactComponent };